<template>
  <main>
    <section
      id="intro"
      class="main-row"
    >
      <b-container>
        <b-row>
          <b-col
            md="7"
            order="2"
            order-md="1"
            class="d-flex flex-column"
          >
            <h1 v-html="$t('meta.title')"></h1>
            <h2 v-html="$t('meta.lead')"></h2>
            <p class="actions">
              <a
                class="btn btn-lg btn-primary"
                :href="`${$t('link.count')}/groups/create`"
              >
                <span>{{ $t('intro.actions.create_group.title') }}</span>
              </a>
            </p>
          </b-col>
          <b-col
            md="3"
            lg="4"
            order="1"
            order-md="2"
            class="d-flex justify-content-center align-items-center"
          >
            <img
              :src="`${$t('baseurl')}img/screens/count.png`"
              alt=""
              class="img-fluid shadow-lg"
            />
          </b-col>
        </b-row>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$refs['what']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span>En savoir plus</span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <section
      id="what"
      ref="what"
    >
      <b-container>
        <b-row>
          <b-col>
            <h2 class="sr-only">
              {{ $t('what.title') }}
            </h2>
            <b-tabs
              align="center"
              card
              pills
            >
              <b-tab
                active
                class="p-0"
                :title="$t('what.tab1.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/simplicite.png`" />
                  </b-col>
                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab1.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab2.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                    order-md="2"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/confort.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab2.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab3.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/vieprivee.png`" />
                  </b-col>
                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab3.desc')"
                  />
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <Limit />

    <how />

    <why />

    <who />

    <sfs />

    <outro />
  </main>
</template>

<script>
import WebScreen from '../../commons/components/WebScreen.vue';
import How from '../../commons/components/hos/How.vue';
import Why from '../../commons/components/hos/Why.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';
import Limit from './Home/Limit.vue';

export default {
  components: {
    WebScreen,
    Limit,
    How,
    Why,
    Who,
    Outro,
    Sfs,
  },
};
</script>

<style lang="scss">
#home {
  background: #fff
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="600px" height="600px" viewBox="0 0 100 100"><path d="M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zM77.53 24.742a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM77.53 74.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z" fill="%23e2e8f0" fill-opacity=".3"/></svg>');
  position: relative;
}

#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, .2));
  padding: 1rem 0 3rem;
  position: relative;

  @media (max-width: 480px) {
    max-height: 645px;
  }

  &::before, &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    -webkit-clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);
    clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
      clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
    }

    // eslint-disable-next-line max-len
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xml%3Aspace%3D%22preserve%22%20width%3D%22180%22%20height%3D%22180%22%3E%3Cpath%20d%3D%22M69.327%2029.651c0%201.768-1.404%203.398-3.77%204.714-2.858%201.58-7.12%202.7-12.01%203.034a14.072%2014.072%200%200%200-1.11-.491c-3.868-1.62-9.013-2.543-14.532-2.543-.815%200-1.61.02-2.405.058l-.108-.058c-2.367-1.316-3.77-2.946-3.77-4.714%200-4.34%208.444-7.855%2018.852-7.855s18.853%203.515%2018.853%207.855zm-34.495%207.964a45.021%2045.021%200%200%201%203.073-.108c6.108%200%2011.528%201.207%2014.975%203.083%202.435%201.325%203.878%202.975%203.878%204.772%200%20.393-.068.776-.206%201.149-.452%201.296-1.67%202.484-3.437%203.486-.01.01-.03.01-.039.02-.03.019-.059.029-.088.048-3.437%201.905-8.916%203.142-15.083%203.142-5.852%200-11.085-1.11-14.552-2.857a9.386%209.386%200%200%201-.54-.285c-2.356-1.306-3.76-2.936-3.76-4.703%200-3.417%205.243-6.333%2012.568-7.404a45.315%2045.315%200%200%201%203.211-.343zM59.9%2045.362c0-2.15-1.04-3.918-2.366-5.243%202.779-.432%205.322-1.12%207.482-2.013%201.6-.668%203.093-1.493%204.31-2.504v3.476c0%201.895-1.62%203.643-4.3%204.998-1.434.726-3.181%201.345-5.145%201.816.01-.177.02-.343.02-.52zm-3.142%209.426c0%201.768-1.404%203.398-3.77%204.714-.177.098-.354.186-.54.284-3.457%201.748-8.69%202.858-14.543%202.858-6.166%200-11.645-1.238-15.082-3.142-2.366-1.316-3.77-2.946-3.77-4.714v-3.476c1.227%201.012%202.71%201.837%204.31%202.504%203.879%201.62%209.024%202.543%2014.542%202.543%205.519%200%2010.664-.923%2014.543-2.543a19.82%2019.82%200%200%200%202.2-1.07%2015.598%2015.598%200%200%200%201.688-1.1c.147-.108.285-.226.422-.334V52.206zm3.142%200V49.103c1.866-.412%203.584-.933%205.116-1.571%201.6-.668%203.093-1.492%204.31-2.504v3.476c0%201.031-.49%202.062-1.462%203.034-1.6%201.6-4.419%202.917-7.983%203.77.01-.166.02-.343.02-.52zM37.905%2065.786c5.519%200%2010.664-.923%2014.543-2.543%201.6-.668%203.093-1.493%204.31-2.504v3.476c0%204.34-8.444%207.855-18.853%207.855-10.408%200-18.852-3.515-18.852-7.855v-3.476c1.227%201.011%202.71%201.836%204.31%202.504%203.879%201.62%209.024%202.543%2014.542%202.543z%22%20style%3D%22stroke-width%3A.0981916%22%2F%3E%3Cpath%20d%3D%22M130.277%20134.822v-25.334c0-1.021.794-1.883%201.814-1.883%2014.028%200%2025.402%2011.374%2025.402%2025.402%200%201.02-.862%201.815-1.882%201.815zM99.43%20138.45c0-13.755%2010.218-25.14%2023.475-26.955%201.043-.148%201.927.692%201.927%201.746v27.024l17.748%2017.747c.76.76.703%202.007-.17%202.62a27.024%2027.024%200%200%201-15.763%205.035c-15.026%200-27.217-12.18-27.217-27.217zm59.695%201.815c1.055%200%201.883.884%201.747%201.928a27.124%2027.124%200%200%201-8.38%2016.137c-.681.635-1.747.59-2.405-.08l-17.997-17.985Z%22%20style%3D%22stroke-width%3A.113402%22%2F%3E%3C%2Fsvg%3E");
    background-size: 300px 300px, 400px 400px, 600px 600px;
    background-blend-mode: lighten;
    background-color: color-mix(in srgb, var(--f-f7) 97%, transparent);
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1{
    color: var(--f-d1);
    font-size: 5rem;
    font-weight: 300;
    margin: 4rem 0 3rem;

    @media (max-width: 992px) {
      font-size: 4rem;
      margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-d1);
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--f-d1);
  }

  .actions {
    margin: 3rem 0 5.5rem;

    @media (max-width: 768px) {
      margin: 2rem 0 0.5rem;
      flex-direction: column;
    }

    a.btn {
      text-align: start;
      span {
        text-transform: uppercase;
      }

      @media (max-width: 992px) {
        padding: .5rem 1rem;
      }

      @media (max-width: 768px) {
        margin: .125rem 0;
      }

      &:first-of-type {
        margin-left: 0;
      }
    }

    .btn-primary {
      background: var(--f-d1);
      color: var(--f-o7);
      font-weight: 700;
      border: none;

      &:focus, &:hover {
        background: var(--f-o7);
        color: var(--f-d1);
      }

      i::before {
        color: inherit;
      }
    }
  }

  .btn-outline-light {
    @media (min-width: 768px) {
      border: transparent;
    }
  }

  img {
    max-height: 25vh;
      border-radius: 1.3rem;

    @media (min-width: 992px) {
      max-height: initial;
    }
  }

  #learn-more {
    label {
      color: var(--f-d1);
      background: none;
      text-decoration: none;

      i::before {
        color: var(--f-d1);
      }
    }

    span {
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }
}

#what {
  padding: 4rem 0;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      font-size: 3rem;
      line-height: 4rem;
    }
  }

  .card-header {
    border: none;
    background: transparent;
    padding: 0;

    .nav li {
      background: var(--f-g1);
      padding: 0.75rem 1.25rem;
    }
  }

  .card-body .row {
    align-items: center
  }

  h3 {
    font-size: 3rem;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 1;
    margin: .5rem 0 1rem;

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    font-size: 1.35rem;
    font-weight: 200;
    line-height: 1.4;

    @media (max-width: 992px) {
      font-size: 1rem;
    }
  }
}

/* SFS */
#support {
  @media (min-width: 992px) { /* cat is hidden by the form below 992px */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 40px);
  }

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  #f-sfs + div { /* #outro parent */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 20px);
  }
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}
</style>
